import { useState } from "react";
import { Plus, X, FolderPlus, UserPlus, CheckSquare, MapPin } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function FloatingActionButton() {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const actions = [
    { 
      icon: <UserPlus className="w-5 h-5" />, 
      label: "New Client", 
      color: "bg-blue-500",
      onClick: () => navigate("/clients?new=true")
    },
    { 
      icon: <FolderPlus className="w-5 h-5" />, 
      label: "New Project", 
      color: "bg-green-500",
      onClick: () => navigate("/projects?new=true")
    },
    { 
      icon: <CheckSquare className="w-5 h-5" />, 
      label: "Add Task", 
      color: "bg-purple-500",
      onClick: () => navigate("/tasks?new=true")
    },
    { 
      icon: <MapPin className="w-5 h-5" />, 
      label: "Site Visit", 
      color: "bg-orange-500",
      onClick: () => navigate("/site-visits?new=true")
    },
  ];

  return (
    <>
      {/* Backdrop */}
      {isOpen && (
        <div 
          className="fixed inset-0 bg-black/40 backdrop-blur-sm z-[44] md:hidden"
          onClick={() => setIsOpen(false)}
        />
      )}

      {/* FAB Container - Mobile Only */}
      <div className="fixed bottom-24 right-4 z-[45] md:hidden">
        {/* Action Items */}
        <div className={`absolute bottom-16 right-0 space-y-3 transition-all duration-300 ${
          isOpen ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'
        }`}>
          {actions.map((action, index) => (
            <div
              key={index}
              className="flex items-center justify-end gap-3 animate-slide-in-right"
              style={{ animationDelay: `${index * 0.05}s` }}
            >
              <span className="px-3 py-1.5 bg-[#1A1A1A] rounded-lg text-white text-sm font-medium shadow-lg whitespace-nowrap">
                {action.label}
              </span>
              <button
                onClick={() => {
                  setIsOpen(false);
                  action.onClick?.();
                }}
                className={`w-12 h-12 rounded-full ${action.color} text-white flex items-center justify-center shadow-lg active:scale-95 transition-transform`}
              >
                {action.icon}
              </button>
            </div>
          ))}
        </div>

        {/* Main FAB Button */}
        <button
          onClick={() => setIsOpen(!isOpen)}
          className={`w-14 h-14 rounded-full bg-[#FF4500] text-white flex items-center justify-center shadow-xl transition-all duration-300 active:scale-95 ${
            isOpen ? 'rotate-45 bg-white/20' : 'rotate-0'
          }`}
          style={{
            boxShadow: isOpen 
              ? '0 4px 20px rgba(255, 69, 0, 0.3)' 
              : '0 4px 30px rgba(255, 69, 0, 0.5)'
          }}
        >
          {isOpen ? <X className="w-6 h-6" /> : <Plus className="w-6 h-6" />}
        </button>
      </div>
    </>
  );
}
